let selectedColor = [];
let selectedGrade = [];
let selectedFabric = [];
let selectedLeather = [];
let itemCount;

class americanSwatch {
  constructor() {
    const checkboxColor = document.querySelectorAll('[data_color]');
    const checkboxGrade = document.querySelectorAll('[data_grade]');
    const checkboxFabric = document.querySelectorAll('[data_fabric]');
    const checkboxLeather = document.querySelectorAll('[data_leather]');
    const gridItems = document.querySelectorAll('[data-swatch-item]');
    itemCount = gridItems.length;

    checkboxColor.forEach(ele => {
      ele.addEventListener("change", () => {
        this._updateSelectedValues(checkboxColor, selectedColor);
        this._loadSwatchGrid();
      });
    });

    checkboxFabric.forEach(ele => {
      ele.addEventListener("change", () => {
        this._updateSelectedValues(checkboxFabric, selectedFabric);
        this._loadSwatchGrid();
      });
    });

    checkboxLeather.forEach(ele => {
      ele.addEventListener("change", () => {
        this._updateSelectedValues(checkboxLeather, selectedLeather);
        this._loadSwatchGrid();
      });
    });

    checkboxGrade.forEach(ele => {
      ele.addEventListener("change", () => {
        this._updateSelectedValues(checkboxGrade, selectedGrade);
        this._loadSwatchGrid();
      });
    });

    gridItems.forEach(ele => {
      ele.addEventListener("click", (event) => {
        this._showItemDetials(event);
      });
    });
  }

  _updateSelectedValues(checkboxes, targetArray) {
    targetArray.length = 0; // Clear old values
    checkboxes.forEach(box => {
      if (box.checked) {
        targetArray.push(box.value);
      }
    });
  }

  _loadSwatchGrid() {
    const gridElements = document.querySelectorAll('[data-swatch-details]');
    const swatchItems = document.querySelectorAll('[data-swatch-item]');
    const emptySearch = document.querySelector("[empty-search]");
    let anyFilterApplied = selectedColor.length || selectedGrade.length || selectedFabric.length || selectedLeather.length;

    if (!anyFilterApplied) {
      // ✅ No filters — show all
      swatchItems.forEach(item => item.classList.remove("d-none"));
      if (emptySearch) emptySearch.classList.add("d-none");
      return;
    }

    let hiddenCount = 0;

    gridElements.forEach(ele => {
      const scriptContent = ele.textContent;
      const data = JSON.parse(scriptContent);
      const swatchItem = ele.closest("[data-swatch-item]");

      let itemVisible = false;

      data.forEach(item => {
        const matchesColor = selectedColor.length === 0 || (item.color && selectedColor.some(color => item.color.includes(color)));
        const matchesFabric = selectedFabric.length === 0 || (item.fabric_type && selectedFabric.some(fab => item.fabric_type.includes(fab)));
        const matchesGrade = selectedGrade.length === 0 || selectedGrade.includes(item.grade);
        const matchesLeather = selectedLeather.length === 0 || selectedLeather.includes(item.leather);

        if (matchesColor && matchesFabric && matchesGrade && matchesLeather) {
          itemVisible = true;
        }
      });

      if (itemVisible) {
        swatchItem.classList.remove("d-none");
      } else {
        swatchItem.classList.add("d-none");
        hiddenCount++;
      }
    });

    if (hiddenCount === itemCount && emptySearch) {
      emptySearch.classList.remove("d-none");
    } else if (emptySearch) {
      emptySearch.classList.add("d-none");
    }
  }

  _showItemDetials(event) {
    let currentEle = event.currentTarget;

    document.querySelectorAll('[data-swatch-item]').forEach(ele => {
      ele.classList.remove("active");
      ele.querySelector(".image_wrapper").classList.remove("active");
      ele.querySelector("[swatch_detials]").removeAttribute('style');
    });

    currentEle.classList.add("active");
    currentEle.querySelector(".image_wrapper").classList.add("active");
  }
}

new americanSwatch();
